import { GetterTree } from 'vuex';
import { AdminState } from './types';
import { RootState } from '@/store/types';
import { WhitelistEntry } from '@/types';

export const getters: GetterTree<AdminState, RootState> = {
  getWhitelist(state): WhitelistEntry[] {
    return state.whitelist;
  },
  getIsWhitelistLoaded(state): boolean {
    return state.isWhitelistLoaded;
  },
};
